import { PortalServicePortalDto } from '@nimbus/portal-service/lib/client/api';
import { axiosClient } from '@nx-frontend/shared/api';
import { assertServiceHost } from '@nx-frontend/shared/api/services/util';

export type GetPortalProps = { host: string; superSecret: string; globalId: string };

export async function getPortal({ host, globalId, superSecret }: GetPortalProps): Promise<PortalServicePortalDto> {
  const response = await axiosClient.get<PortalServicePortalDto>(`${assertServiceHost(host)}/v1/portals`, {
    params: {
      portal: globalId,
    },
    secret: superSecret,
  });

  return response.data;
}
